import React__default, { useContext } from 'react';
import { L as LocalizationContext } from '../../chunks/bundle-s19NuPaM.js';
import MessageInput from '../../ui/MessageInput.js';
import { u as useOpenChannelContext } from '../../chunks/bundle-DUcSFu50.js';
import '../../chunks/bundle-Ca6003_X.js';
import '../../chunks/bundle-DLMIiDGU.js';
import '../../chunks/bundle-DGylLBIn.js';
import '../../chunks/bundle-B667kaG5.js';
import '../../chunks/bundle-DgPFpYZt.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../chunks/bundle-DDzCV2KR.js';
import '../../chunks/bundle-y-5JpD-m.js';
import 'dompurify';
import '../../chunks/bundle-DgkSQIK-.js';
import '../../chunks/bundle-C6zIjPZB.js';
import '../../chunks/bundle-rD5ecRD2.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-91Yg-xh6.js';
import '../../chunks/bundle-BVK-TCRK.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-DDAJSpJT.js';
import '../../chunks/bundle-DrrIZ2Uk.js';
import '../../chunks/bundle-DUh4gAyx.js';
import '../../chunks/bundle-BSmdL6m-.js';
import '../../chunks/bundle-DvAn8oVD.js';
import '../../chunks/bundle-ByN2OJfK.js';
import '../../chunks/bundle-Dcb1dUnS.js';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-C6mXReBM.js';
import '../../chunks/bundle-COgxXrpf.js';
import '../../chunks/bundle-_G98ZxIs.js';
import '../../chunks/bundle-C6Xiexo0.js';
import '../../chunks/bundle-DqU2mzDL.js';
import '../../chunks/bundle-C_bjYbrN.js';
import '../../hooks/useModal.js';
import '../../chunks/bundle-CCo7ZdMR.js';
import 'react-dom';
import '../../chunks/bundle-CPSJLEbT.js';

var OpenChannelInput = React__default.forwardRef(function (props, ref) {
    var _a = useOpenChannelContext(), currentOpenChannel = _a.currentOpenChannel, disabled = _a.disabled, handleSendMessage = _a.handleSendMessage, handleFileUpload = _a.handleFileUpload, amIMuted = _a.amIMuted;
    var channel = currentOpenChannel;
    var stringSet = useContext(LocalizationContext).stringSet;
    var value = props.value;
    function getPlaceHolderString() {
        if (amIMuted) {
            return stringSet.MESSAGE_INPUT__PLACE_HOLDER__MUTED;
        }
        if (disabled) {
            return stringSet.MESSAGE_INPUT__PLACE_HOLDER__DISABLED;
        }
        return '';
    }
    if (!channel) {
        return null;
    }
    return (React__default.createElement("div", { className: "sendbird-openchannel-footer" },
        React__default.createElement(MessageInput, { channel: currentOpenChannel, ref: ref, value: value, disabled: disabled, isVoiceMessageEnabled: false, onSendMessage: handleSendMessage, onFileUpload: handleFileUpload, placeholder: getPlaceHolderString() })));
});

export { OpenChannelInput as default };
//# sourceMappingURL=OpenChannelInput.js.map
